import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import CreatePartie from '../views/CreatePartie.vue'
import JoinPartie from '../views/JoinPartie.vue'
import Game from '../views/Game.vue'

Vue.use(VueRouter)

const routes = [
  {path: '/', name: 'Home', component: Home},
  {path: '/create-partie', name: 'CreatePartie', component: CreatePartie},
  {path: '/join-partie', name: 'JoinPartie', component: JoinPartie},
  {path: '/game/:partieToken', name: 'Game', component: Game},
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
